<div class="labour-rate-card">
  <div class="header-controls">
    <!-- <mat-form-field appearance="fill" style="width: 200px;">
      <mat-label>Company</mat-label>
      <mat-select [(value)]="selectedCompany" (selectionChange)="onCompanyChange()">
        <mat-option *ngFor="let company of companies" [value]="company">{{ company }}</mat-option>
      </mat-select>
    </mat-form-field> -->
    <mat-form-field appearance="fill" style="width: 200px;">
      <mat-label>Company</mat-label>
      <mat-select [(value)]="selectedCompany" (selectionChange)="loadTableData()">
        <mat-option *ngFor="let company of companies" [value]="company">
          {{ company }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div style="  display: flex;">
      <div class="add-label-btn" (click)="showLabelPopup = true">Add Ratecard</div>
      <div class="add-label-btn" (click)="showAddForm = true">Add Ratecard Labour Item</div>
    </div>
  </div>

<div class="responsive-table">
  <table class="mat-elevation-z8" style="width: 100%; border-collapse: collapse; text-align: center;margin-bottom: 5%;box-shadow: none;">
    <thead>
      <tr class="heading-line">
        <th>Car Size</th>
        <th>Labour Item</th>
        <th>MRP</th>
        <th>Status</th>
        <th>Edit</th>
      </tr>
    </thead>
    <tbody>
      <!-- ADD MODE ROW -->
      <tr *ngIf="showAddForm">
        <td>
          <input matInput [(ngModel)]="newItem.carSize" style="width: 100px;" />
        </td>
        <td>
          <input matInput [(ngModel)]="newItem.labourItem" style="width: 150px;" />
        </td>
        <td>
          <input matInput [(ngModel)]="newItem.mrp" style="width: 80px;" />
        </td>
        <td>
          <mat-form-field appearance="fill" style="width: 150px; margin: 0;">
            <mat-select [(ngModel)]="newItem.status" placeholder="Status">
              <mat-option [value]="1">Active</mat-option>
              <mat-option [value]="0">Inactive</mat-option>
            </mat-select>
          </mat-form-field>

        </td>
        <td>
          <button mat-icon-button color="primary" (click)="addNewItem()" matTooltip="Save">
            <mat-icon>check</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="cancelAdd()" matTooltip="Cancel">
            <mat-icon>close</mat-icon>
          </button>
        </td>
      </tr>

      <!-- NORMAL ROWS -->
      <ng-container *ngIf="!showAddForm">
        <ng-container *ngFor="let element of tableData.data; let i = index">
          <tr>
      <td>
        <ng-container *ngIf="editIndex === i; else carSizeText">
          <input [(ngModel)]="editItem.carSize" />
        </ng-container>
        <ng-template #carSizeText>{{ element.carSize }}</ng-template>
      </td>
      <td>
        <ng-container *ngIf="editIndex === i; else labourNameText">
          <input [(ngModel)]="editItem.labourItem" />
        </ng-container>
        <ng-template #labourNameText>{{ element.labourName }}</ng-template>
      </td>
      <td>
        <ng-container *ngIf="editIndex === i; else labourAmountText">
          <input [(ngModel)]="editItem.mrp" />
        </ng-container>
        <ng-template #labourAmountText>{{ element.labourAmount }}</ng-template>
      </td>
          <td>
            <ng-container *ngIf="editIndex === i; else statusText">
              <mat-form-field appearance="fill" style="width: 120px; margin: 0;">
                <mat-select [(ngModel)]="editItem.status" placeholder="Status">
                  <mat-option [value]="1">Active</mat-option>
                  <mat-option [value]="0">Inactive</mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <ng-template #statusText>
              {{ element.status == 1 ? 'Active' : 'Inactive' }}
            </ng-template>
          </td>


    <td>
        <ng-container *ngIf="editIndex === i; else editBtn">
          <button mat-icon-button color="primary" (click)="saveEdit(element)" matTooltip="Save">
            <mat-icon>check</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="cancelEdit()" matTooltip="Cancel">
            <mat-icon>close</mat-icon>
          </button>
        </ng-container>
        <ng-template #editBtn>
          <button mat-icon-button color="primary" (click)="startEdit(i)" matTooltip="Edit">
            <mat-icon>edit</mat-icon>
          </button>
        </ng-template>
      </td>
          </tr>
        </ng-container>
      </ng-container>

      <tr *ngIf="!showAddForm && tableData.data.length === 0">
        <td colspan="5" style="padding: 12px;">No data available</td>
      </tr>
    </tbody>
  </table>
</div>

</div>

<!-- Popup -->
<div *ngIf="showLabelPopup" class="popup-overlay">
  <div class="popup-content">
    <mat-icon  (click)="showLabelPopup = false" class="popup-close">close</mat-icon>
    <h3>Add Ratecard</h3>
    
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Enter Name</mat-label>
      <input matInput [(ngModel)]="labelName">
    </mat-form-field>

    <div class="popup-actions">
      <button mat-button (click)="showLabelPopup = false">Cancel</button>
      <button mat-raised-button color="primary" (click)="saveLabel()">Save</button>
    </div>
  </div>
</div>